import { motion } from 'framer-motion';

const logos = [
  'ElevenLabs',
  'Runway',
  'Veo',
  'Kling',
  'Flux',
  'Ideogram',
  'Seedream',
];

const LogoMarquee = () => {
  return (
    <section className="py-12 border-y border-white/5" data-testid="logo-marquee">
      <div className="max-w-7xl mx-auto px-6">
        <p className="text-center text-sm text-gray-500 uppercase tracking-widest mb-8">
          Powered by the world's best AI models
        </p>
        
        <div className="marquee-container">
          <div className="marquee-content">
            {[...logos, ...logos].map((logo, index) => (
              <span 
                key={index}
                className="inline-flex items-center mx-12 text-2xl font-mono font-bold text-white/40 hover:text-white/70 transition-opacity cursor-default"
              >
                <span className="text-brand-primary/50 mr-4">✦</span>
                {logo}
              </span>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default LogoMarquee;
